import { OnInit, EventEmitter, ChangeDetectorRef, TemplateRef, ElementRef } from '@angular/core';
import { GalleryColumns } from 'src/app/gallery/models/gallery-list-columns.enum';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
var GalleryCardComponent = /** @class */ (function () {
    function GalleryCardComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.galleryColumns = GalleryColumns;
        this.selectLabel = 'Select';
        this._columns = [
            GalleryColumns.Model,
            GalleryColumns.Tags,
            GalleryColumns.CreatedBy,
            GalleryColumns.UpdatedBy,
            GalleryColumns.Actions
        ];
        this.checkable = false;
        this.checked = false;
        this.showActions = false;
        this.selectBookmark = new EventEmitter();
        this.checkedChange = new EventEmitter();
    }
    Object.defineProperty(GalleryCardComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (value) {
            this._columns = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryCardComponent.prototype, "result", {
        get: function () {
            return this._result;
        },
        set: function (value) {
            this._result = value;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    GalleryCardComponent.prototype.ngOnInit = function () {
    };
    GalleryCardComponent.prototype.hasColumns = function () {
        var _this = this;
        var columns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            columns[_i] = arguments[_i];
        }
        return columns.some(function (column) { return _this.hasColumn(column); });
    };
    GalleryCardComponent.prototype.hasColumn = function (value) {
        return this.columns.some(function (column) { return column === value; });
    };
    GalleryCardComponent.prototype.handleSelect = function (result) {
        this.selectBookmark.emit(result);
    };
    GalleryCardComponent.prototype.handleCheckedChange = function (event) {
        this.checkedChange.emit({ id: event.source.value, checked: event.checked });
    };
    return GalleryCardComponent;
}());
export { GalleryCardComponent };
